import { render, staticRenderFns } from "./PartnerUserRole.vue?vue&type=template&id=01cdef9b&"
import script from "./PartnerUserRole.vue?vue&type=script&lang=ts&"
export * from "./PartnerUserRole.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerUserRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports